export default __webpack_public_path__ + "static/media/NubMaduroClosed.ab24e07e.jpg";